import { render, staticRenderFns } from "./PasoCincoComponent.vue?vue&type=template&id=3b1e12b6&scoped=true"
import script from "./PasoCincoComponent.vue?vue&type=script&lang=js"
export * from "./PasoCincoComponent.vue?vue&type=script&lang=js"
import style0 from "./PasoCincoComponent.vue?vue&type=style&index=0&id=3b1e12b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e12b6",
  null
  
)

export default component.exports